import { ProjectDtoRelV2 } from '../../../commonTypes/project.types';
import { ProjectCard } from './ProjectCard';

interface StatusColumnProps {
    status: string;
    label: string;
    color: string;
    projects: ProjectDtoRelV2[];
    onDragStart: (e: React.DragEvent<HTMLDivElement>, projectId: string) => void;
    onDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
    onDrop: (e: React.DragEvent<HTMLDivElement>, status: string) => void;
    onViewDetails: (projectId: string) => void;
    disabledProjectIds: Set<string>;
    showPremiumTooltip: boolean;
}

export const StatusColumn = ({
    status,
    label,
    color,
    projects,
    onDragStart,
    onDragOver,
    onDrop,
    onViewDetails,
    disabledProjectIds,
    showPremiumTooltip,
}: StatusColumnProps) => {
    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        onDrop(e, status);
    };

    return (
        <div className="status-column">
            <div className="status-column__header">
                <div className="status-column__indicator" style={{ backgroundColor: color }} />
                <h2 className="status-column__title">{label}</h2>
            </div>
            <div className="status-column__content" onDragOver={onDragOver} onDrop={handleDrop}>
                {projects.length === 0 ? (
                    <div className="status-column__empty">No projects</div>
                ) : (
                    projects.map(project => (
                        <ProjectCard
                            key={project.id}
                            project={project}
                            statusColor={color}
                            onDragStart={onDragStart}
                            onViewDetails={onViewDetails}
                            isDisabled={disabledProjectIds.has(project.id)}
                            showPremiumTooltip={showPremiumTooltip}
                        />
                    ))
                )}
            </div>
        </div>
    );
};
